import React, {ReactElement} from 'react';

import GroupsIcon from '@mui/icons-material/Groups';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AdbIcon from '@mui/icons-material/Adb';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import FlightIcon from '@mui/icons-material/Flight';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import TaskIcon from '@mui/icons-material/Task';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import {ResourceType} from '../@types/resource-type';
import {
    AdminPanelSettings,
    Assessment,
    AssessmentOutlined,
    Category,
    FollowTheSigns
} from '@mui/icons-material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSitemap, faUserGraduate} from '@fortawesome/free-solid-svg-icons';

export function resourceIcon(type: ResourceType): ReactElement {
    switch (type) {
        case ResourceType.USERS:
            return <AdminPanelSettings fontSize="small" />;
        case ResourceType.SERVICE_USER_ACCOUNTS:
            return <FontAwesomeIcon icon={faUserGraduate} />;
        case ResourceType.GROUPS:
            return <GroupsIcon fontSize="small" />;
        case ResourceType.GROUP_ROLE_PERMISSIONS:
            return <FollowTheSigns fontSize="small" />;
        case ResourceType.EVENT_SEQUENCES:
            return <Avatar sx={{ width: 24, height: 24 }}>
                <Typography variant='caption'>SV</Typography>
            </Avatar>;
        case ResourceType.EVENT_SEQUENCE_TREES:
            return <FontAwesomeIcon icon={faSitemap} style={{fontSize: '16px'}} />;
        case ResourceType.EVENT_SEQUENCE_HISTORY:
        case ResourceType.EVENT_SEQUENCE_HISTORY_TREES:
        case ResourceType.COMPONENT_HISTORY:
        case ResourceType.COMPONENT_HISTORY_TREE:
            return <HistoryIcon fontSize="small" />;
        case ResourceType.EVENT_SEQUENCE_SENSITIVIY_ANALYSIS:
            return <ArchitectureIcon fontSize="small" />;
        case ResourceType.EVENT_SEQUENCE_UNCERTAINTY_ANALYSIS:
            return <BarChartIcon fontSize="small" />;
        case ResourceType.UNKNOWN:
        case ResourceType.SAFETY_MODELS:
            return <AccountTreeIcon  fontSize = "small"/>;
        case ResourceType.NEW_OCCURRENCE_REPORTS:
            return <FlightIcon fontSize="small" />;
        case ResourceType.FOUNDRY_EVENTS:
            return <ConnectingAirportsIcon fontSize="small" />;
        case ResourceType.OCCURRENCE_REPORT_DESCRIPTORS:
            return <Category fontSize="small" />;
        case ResourceType.OCCURRENCE_REPORTS:
            return <FlightIcon fontSize="small" />;
        case ResourceType.OCCURRENCE_TYPES:
            return <Category fontSize="small" />;
        case ResourceType.PERFORMANCE_SHAPING_FACTORS:
            return <PrecisionManufacturingIcon fontSize = "small"/>;
        case ResourceType.TRAFFIC_MODELS:
            return <FlightIcon  fontSize = "small"/>;
        case ResourceType.OPERATIONAL_CHANGES:
            return <NetworkCheckIcon  fontSize = "small"/>;
        case ResourceType.WORKSHOPS:
            return <TaskIcon  fontSize = "small"/>;
        case ResourceType.RISK_FORECASTS:
            return <TrendingDownIcon fontSize="small" />;
        case ResourceType.INTEGRATED_RISK_PICTURES:
            return <AssessmentOutlined fontSize="small" />;
        case ResourceType.IRP_WORKBOOK:
            return <Assessment fontSize="small" />;
        case ResourceType.COMPONENT:
            return <Avatar sx={{ width: 24, height: 24 }}>
                <Typography variant='caption'>C</Typography>
            </Avatar>
        case ResourceType.COMPONENT_TREE:
            return <DeviceHubIcon fontSize="small" />;
        case ResourceType.COMPONENT_MAPPING:
            return <TableChartOutlinedIcon fontSize="small" />;
        default:
            return <AdbIcon  fontSize = "small"/>;
    }
}
